module.exports = __webpack_public_path__ + "img/022.45b4d6c0.svg";